// 路由配置 - 精简版
const meta = (transition?: string) => ({ keepAlive: false, transition });

const routes = [
  // 首页
  { path: "/", component: () => import("@/pages/Info/InfoPage.vue"), meta: meta() },
  { path: "/info", component: () => import("@/pages/Info/InfoPage.vue"), meta: meta() },
  { path: "/home-responsive", component: () => import("@/pages/home/HomeResponsive.vue"), meta: meta("fade") },
  { path: "/Service", component: () => import("@/pages/home/ServicePage.vue"), meta: meta() },
  { path: "/enterprise", component: () => import("@/pages/enterprise/EnterprisePage.vue"), meta: meta() },
  
  // 认证
  { path: "/Auth1", component: () => import("@/pages/Auth/AuthPage.vue"), meta: meta("slide-up") },
  { path: "/ChangePassword", component: () => import("@/pages/Auth/ChangePasswordPage.vue"), meta: meta("slide-up") },
  { path: "/user/profile", component: () => import("@/pages/Auth/UserProfilePage.vue"), meta: meta("slide-up") },
  { path: "/user/change-password", component: () => import("@/pages/Auth/UserChangePasswordPage.vue"), meta: meta("slide-up") },
  { path: "/auth/third-party/:provider/callback", component: () => import("@/pages/Auth/ThirdPartyCallback.vue"), meta: meta("fade") },
  { path: "/auth/user-agreement", component: () => import("@/pages/Auth/UserAgreement.vue"), meta: meta("slide-up") },
  { path: "/auth/privacy-policy", component: () => import("@/pages/Auth/PrivacyPolicy.vue"), meta: meta("slide-up") },
  
  // 招聘
  { path: "/recruit", component: () => import("@/pages/recruit/RecruitPage.vue"), meta: meta() },

  { path: "/lottery-interview", component: () => import("@/pages/recruit/LotteryInterview.vue"), meta: meta("slide-left") },
  { path: "/recruit/lottery-interview", component: () => import("@/pages/recruit/LotteryInterview.vue"), meta: meta("slide-left") },
  
  // 报名
  { path: "/p-home", component: () => import("@/pages/home/PHome.vue"), meta: meta("fade") },
  { path: "/home", component: () => import("@/pages/home/PHome.vue"), meta: meta("fade") },
  { path: "/registration", component: () => import("@/pages/recruit/Registration.vue"), meta: meta("slide-left") },
  { path: "/recruit/registration", component: () => import("@/pages/recruit/Registration.vue"), meta: meta("slide-left") },

  // 培训
  { path: "/training", component: () => import("@/pages/training/Training.vue"), meta: meta("slide-left") },
  { path: "/training/player/:id", component: () => import("@/pages/training/TrainingPlayer.vue"), meta: meta("slide-left") },
  
  // 签约
  { path: "/contract/signing", component: () => import("@/pages/contract/Signing.vue"), meta: meta("slide-left") },
  { path: "/contract/signing-success", component: () => import("@/pages/contract/SigningSuccess.vue"), meta: meta("slide-left") },
  
  // 我的
  { path: "/p-personal-center", component: () => import("@/pages/user/PersonalCenter.vue"), meta: meta("slide-left") },
  { path: "/user/messages", component: () => import("@/pages/user/MyMessages.vue"), meta: meta("slide-left") },
  { path: "/user/application-progress", component: () => import("@/pages/user/ApplicationProgress.vue"), meta: meta("slide-left") },
  { path: "/user/settings", component: () => import("@/pages/user/Settings.vue"), meta: meta("slide-left") },
  
  // 客服
  { path: "/customer-service", component: () => import("@/pages/customer/CustomerServicePage.vue"), meta: meta() },
  
  // 关于我们
  { path: "/about/about-us", component: () => import("@/pages/about/AboutUs.vue"), meta: meta("slide-left") },
  { path: "/about/project-introduction", component: () => import("@/pages/about/ProjectIntroduction.vue"), meta: meta("slide-left") },
  { path: "/p-project_introduction", component: () => import("@/pages/about/ProjectIntroduction.vue"), meta: meta("slide-left") },
  
  // 社区
  { path: "/community", component: () => import("@/pages/community/List.vue"), meta: meta("slide-left") },
  { path: "/community/:id", component: () => import("@/pages/community/Detail.vue"), meta: meta("slide-left") },
  
  // 视频
  { path: "/home/index2", component: () => import("@/pages/home/index.vue"), meta: meta("slide-left") },
  { path: "/home/videolist", component: () => import("@/pages/home/videolist.vue"), meta: meta("slide-left") },
  { path: "/home/video", component: () => import("@/pages/home/video.vue"), meta: meta("slide-left") },
  { path: "/home/videoVip", component: () => import("@/pages/home/videoVip.vue"), meta: meta("slide-left") },
  
  // 支付
  { path: "/pay", component: () => import("@/pages/home/payPage.vue"), meta: meta("slide-up") },
  { path: "/payResult", component: () => import("@/pages/home/payResult.vue"), meta: meta("slide-up") },
];
export default routes;
